// Carry Roll OptimizeScreen — Screen 6. Progressive disclosure: lead with the
// single highest-value gain (the answer), then tuck the back-solve, optimizers,
// sensitivity, fixable-priority, and triangle machinery behind disclosure
// controls so the screen reads as a confident recommendation rather than a wall
// of simultaneous analytic machinery.

import { Collapsible } from '../components/calculator/Collapsible';
import { OptimizeLead } from '../components/optimize/OptimizeLead';
import { InverseSolver } from '../components/optimize/InverseSolver';
import { SensitivityChart } from '../components/optimize/SensitivityChart';
import { OptimizationTriangle } from '../components/optimize/OptimizationTriangle';
import { OptimizerPanel } from '../components/optimize/OptimizerPanel';
import { FixablePriority } from '../components/optimize/FixablePriority';

export default function OptimizeScreen() {
  return (
    <div
      className="measure flex flex-col gap-4"
      data-testid="optimize-screen"
    >
      <h2 className="section-title">
        Optimize
      </h2>

      {/* The answer — always visible. */}
      <OptimizeLead />

      {/* Machinery — tucked behind disclosure controls (closed by default to
          reduce perceived complexity; capability is fully preserved). */}
      <Collapsible title="Back-solve" testId="optimize-back-solve" defaultOpen={false}>
        <InverseSolver />
      </Collapsible>
      <Collapsible title="Optimizers" testId="optimize-optimizers" defaultOpen={false}>
        <OptimizerPanel />
      </Collapsible>
      <Collapsible title="Sensitivity analysis" testId="optimize-sensitivity" defaultOpen={false}>
        <SensitivityChart />
      </Collapsible>
      <Collapsible title="Fixable priorities" testId="optimize-fixable" defaultOpen={false}>
        <FixablePriority />
      </Collapsible>
      <Collapsible title="Optimization triangle" testId="optimize-triangle" defaultOpen={false}>
        <OptimizationTriangle />
      </Collapsible>
    </div>
  );
}
